import * as React from 'react';
import PropTypes from 'prop-types';

import { Button, Checkbox } from 'antd';
import { isEqual, groupBy } from 'lodash';

import s from './style/Roles.pcss';
import { getGrantListAsAdmin } from '../../http';
import Loader from '../../../shared/components/Loader/Loader';


export default class Grants extends React.Component {
  static propTypes = {
    isLocked: PropTypes.bool.isRequired,
    roleGrants: PropTypes.arrayOf(PropTypes.string).isRequired,
    onSave: PropTypes.func.isRequired,
  };

  state = {
    editMode: false,
    grants: [],
    roleGrants: this.props.roleGrants,
  };

  componentDidMount() {
    getGrantListAsAdmin().then(grants => this.setState({ grants }));
  }

  componentWillReceiveProps(nextProps) {
    if (!isEqual(this.props.roleGrants, nextProps.roleGrants)) {
      this.setState({ roleGrants: nextProps.roleGrants, editMode: false });
    }
  }

  setEditMode = () => this.setState({ editMode: true });
  onSave = () => {
    this.setState({ saving: true }, () => {
      this.props.onSave(this.state.roleGrants).then(() => {
        this.setState({ editMode: false, saving: false });
      });
    });
  };

  onValueChange = (grant) => {
    let roleGrants = [...this.state.roleGrants];
    const wasChecked = roleGrants.some(g => g === grant);
    if (wasChecked) {
      roleGrants = roleGrants.filter(g => g !== grant);
    } else {
      roleGrants = roleGrants.concat(grant);
    }
    this.setState({ roleGrants });
  };

  getCheckbox = (grant) => {
    const { editMode, roleGrants, saving } = this.state;
    const disabled = !editMode || saving;
    const checked = roleGrants.some(g => g === grant.id);
    return (
      <Checkbox
        key={grant.id}
        onChange={() => this.onValueChange(grant.id)}
        checked={checked}
        disabled={disabled}
      >
        {grant.description}
      </Checkbox>
    );
  };

  render() {
    const { isLocked } = this.props;
    const { editMode, grants, saving } = this.state;
    const grouppedGrants = groupBy(grants, 'type.description');
    return (
      <div className={s.grantsContainer}>
        {!isLocked &&
          <div className={s.editModeContainer}>
            {editMode &&
              <Button
                type="primary"
                className={s.successBtn}
                onClick={this.onSave}
                disabled={saving}
              >
                {saving
                  ? <Loader fullScreen={false} size={20} />
                  : 'Сохранить'
                }
              </Button>
            }
            {!editMode &&
              <Button type="primary" className={s.editBtn} onClick={this.setEditMode}>
                Редактировать
              </Button>
            }
          </div>
        }
        {isLocked &&
          <div className={s.lockedContainer}>
            <div className={s.lockedIcon} />
            <div className={s.hint}>
              Внимание! Вы не можете редактировать эту роль, поскольку она была преднастроена!
            </div>
          </div>
        }
        {Object.keys(grouppedGrants)
          .map(key => (
            <div key={key} className={s.block}>
              <div className={s.blockLabel}>{key}</div>
              {grouppedGrants[key].map(grant => this.getCheckbox(grant))}
            </div>
          ))
        }
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/Root/pages/Roles/Grants.js